// Dados do FAQ
export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: '1',
    question: 'Como faço para tirar dúvidas sobre o proNotas?',
    answer: 'Nossa equipe de suporte está sempre disponível para ajudar! Você pode entrar em contato através do link "Contato" no menu superior, ligar para (11) 9876-5432, ou acessar nossos manuais e vídeos explicativos. Para uma visão geral, visite nosso canal no YouTube.',
  },
  {
    id: '2',
    question: 'Como funciona o suporte?',
    answer: 'Oferecemos suporte multicanal através de telefone, chat online, ticket e WhatsApp. Nossos especialistas estão disponíveis para ajudar você em todos os momentos, com horário estendido para planos Premium.',
  },
  {
    id: '3',
    question: 'Existe algum custo de instalação?',
    answer: 'Não! O proNotas é 100% online e não possui custo de instalação. Basta se inscrever e começar a usar imediatamente. Sem taxas de ativação ou configuração inicial.',
  },
  {
    id: '4',
    question: 'Terei backup dos meus dados? Eles estão seguros?',
    answer: 'Sim! Todos os seus dados são armazenados com segurança em servidores na nuvem com backup automático diário. Utilizamos criptografia de ponta a ponta e seguimos os mais altos padrões de segurança de dados.',
  },
  {
    id: '5',
    question: 'O que acontece se ficar sem internet?',
    answer: 'O proNotas é uma plataforma 100% online, então é necessário ter conexão com a internet para acessar o sistema. No entanto, oferecemos sincronização automática quando a conexão for restabelecida.',
  },
  {
    id: '6',
    question: 'Possui módulo offline?',
    answer: 'Atualmente, o proNotas é uma plataforma totalmente online. Estamos trabalhando em recursos offline para funcionalidades específicas, que estarão disponíveis em breve.',
  },
  {
    id: '7',
    question: 'Qual a configuração mínima para utilização do sistema?',
    answer: 'O proNotas funciona em qualquer navegador moderno (Chrome, Firefox, Safari, Edge) em computadores, tablets ou smartphones. Não é necessário instalar nenhum software adicional.',
  },
];
